import React from "react";

import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";

import CardImageButton from "../../../components/cards/CardImageButton";
import useMarketPlacesController from "./MarketplacesController";
import {
  useMarketplaceList,
  useTabIndex,
  useMarketplacesConectados,
  useMarketplace,
  useCnpj,
} from "../../../context/integracao/MarketplacesContext";

import "./Marketplaces.css";

const MarketplacesTabMarketplaces = ({ ...props }) => {
  // Filtros
  const { cnpj } = useCnpj();
  const { marketplaceList } = useMarketplaceList();
  const { setTabIndex } = useTabIndex();
  const { marketplacesConectados } = useMarketplacesConectados();
  const { setMarketplace } = useMarketplace();

  // Adiciona as funções vindas do MarketPlacesController
  const { vincularMarketplace } = useMarketPlacesController();

  // Carrega todos os campos específicos que iniciam com a tela (usando useEffect para serem carregados somente uma vez)

  // Abaixo será feito somente a construção da tela

  // Botões de conectar/desconectar/configurações dos marketplaces

  const btnConectarOnClick = async (value, marketplaceConectado) => {
    if (!marketplaceConectado) {
      await vincularMarketplace(cnpj, value.id);
    } else {
      sessionStorage.setItem("marketplaceId", value.id);
      setMarketplace(marketplaceConectado);
      setTabIndex(1);
    }
  };

  return (
    <>
      <h3>
        Abaixo escolha qual marketplace deseja anunciar seus produtos, no
        primeiro acesso, será necessário informar seu login e senha do
        marketplace para sincronizar as informações.
      </h3>
      <Grid container spacing={2}>
        {marketplaceList.map((value) => {
          let marketplaceConectado = marketplacesConectados.find((mktpList) => {
            return mktpList.id === value.id;
          });

          let btnText = "Conectar";
          if (marketplaceConectado) btnText = "Conectado";
          // marketplace indisponível
          if (!value.ativo) btnText = "Indisponível";

          return (
            <Grid item key={"grid_marketplace_item_" + value.id}>
              <CardImageButton
                imgStyle={{ width: "230px", height: "160px" }}
                image={value.picture}
                itemId={"card_con_" + value.id}
                key={"img_con_" + value.id}
              >
                <Button
                  key={"btn_conectar_" + value.id}
                  onClick={() => {
                    btnConectarOnClick(value, marketplaceConectado);
                  }}
                  disabled={!value.ativo ? true : null}
                  style={{
                    backgroundColor: !value.ativo ? "#ccc" : null,
                  }}
                >
                  {btnText}
                </Button>
              </CardImageButton>
            </Grid>
          );
        })}
      </Grid>
    </>
  );
};

export default MarketplacesTabMarketplaces;
